__turbopack_context__.v({
  "body": "KK7IdW_body",
  "close": "KK7IdW_close",
  "closeIcon": "KK7IdW_closeIcon",
  "default": "KK7IdW_default",
  "error": "KK7IdW_error",
  "icon": "KK7IdW_icon",
  "info": "KK7IdW_info",
  "root": "KK7IdW_root",
  "statusIcon": "KK7IdW_statusIcon",
  "success": "KK7IdW_success",
  "warning": "KK7IdW_warning",
});
